import axios from 'axios'
import type {
  CebiGlassInfoDto,
  GetCebiGlassRequest,
  GetMakersRequest,
  GetModelsBaseRequest,
  GetModelsRequest,
  VehiclesIdentificationDto,
  VehicleValuationDto,
  VinOnlineVehicleDto,
} from 'BrokerTsLib/src/dtos'
import type { GenericQueryOptions, VehicleValuationModel } from 'brokertslib/src/hooks'
import { longStaleTime } from 'brokertslib/src/hooks'
import { useMutation, useQuery } from 'react-query'

import { useUrl } from '.'
import { Apis } from '../appSettings/AppSettings'

export const useFindVehicle = () => {
  const url = useUrl(Apis.vinOnline)

  return useMutation((data: VehicleIdentificationPropsDto) =>
    axios.post<VinOnlineVehicleDto>(`${url}/FindVehicle`, data))
}

export const useVehicleIdentification = () => {
  const url = useUrl(Apis.vinOnline)

  return useMutation((data: VehicleIdentificationPropsDto) =>
    axios.post<VehiclesIdentificationDto>(`${url}/VehicleIdentification`, data))
}

export const useVehicleValuation = () => {
  const url = useUrl(Apis.vinOnline)

  return useMutation((data: VehicleValuationModel) =>
    axios.post<VehicleValuationDto>(`${url}/VehicleValuation`, data))
}

export const useCebiGlass = () => {
  const url = useUrl(Apis.vinOnline)

  return useMutation((data: GetCebiGlassRequest) =>
    axios.post<CebiGlassInfoDto>(`${url}/CebiGlass`, data))
}

export type VehicleIdentificationPropsDto = {
  paramsId?: string | null
  spz?: string | null
  vin?: string | null
  techCertNumber?: string | null
}

export const useGetMakers = (request: GetMakersRequest) => {
  const url = useUrl(Apis.vinOnline)

  return useQuery({
    queryKey: ['vinOnline-useGetVehicleMakers', request.categoryId, request.fuelId],
    queryFn: async () => {
      if (!request.categoryId)
        return []

      const response = await axios.post<string[]>(`${url}/GetMakers`, request)

      return response.data
    },
    staleTime: longStaleTime
  })
}

export const useGetModelsBase = (request: GetModelsBaseRequest) => {
  const url = useUrl(Apis.vinOnline)

  return useQuery({
    queryKey: ['vinOnline-useGetModelsBase', request.categoryId, request.fuelId, request.maker],
    queryFn: async () => {
      if (!request.categoryId && !request.maker)
        return []

      const response = await axios.post<string[]>(`${url}/GetModelsBase`, request)

      return response.data
    },
    staleTime: longStaleTime,
  })
}


export const useGetModels = (request: GetModelsRequest) => {
  const url = useUrl(Apis.vinOnline)

  return useQuery({
    queryKey: [
      'vinOnline-useGetModels',
      request.categoryId,
      request.fuelId,
      request.maker,
      request.modelBase,
    ],
    queryFn: async () => {
      if (!request.categoryId && !request.maker)
        return []

      const response = await axios.post<string[]>(`${url}/GetModels`, request)

      return response.data
    },
    staleTime: longStaleTime
  })
}

export const useGetAllMakers = (
  options?: GenericQueryOptions<string[]>,
) => {
  const url = useUrl(Apis.vinOnline)

  return useQuery({
    queryKey: ['vinOnline-useGetAllVehicleMakers'],
    queryFn: () => axios.post<string[]>(`${url}/GetAllMakers`),
    staleTime: longStaleTime,
    ...options
  })
}